var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.compact
    ? _c(
        "div",
        { staticClass: "priority-compact" },
        [
          _c(
            "w-chip",
            {
              ref: "chip",
              staticClass: "priority-chip",
              class: { unset: _vm.value == 0 },
              style: _vm.selectedChipStyle,
              attrs: { clickable: !_vm.readonly },
              nativeOn: {
                mousedown: function ($event) {
                  $event.stopPropagation()
                },
                mouseup: function ($event) {
                  $event.stopPropagation()
                },
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.toggle()
                },
              },
            },
            [
              _c("span", { staticClass: "priority-text" }, [
                _vm._v(_vm._s(_vm.$ct("priorities." + _vm.value))),
              ]),
              !_vm.readonly
                ? _c("w-fa", {
                    staticClass: "priority-caret",
                    attrs: { icon: "caret-down" },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.open
            ? _c(
                "div",
                {
                  ref: "menu",
                  staticClass: "priority-items drop-shadow",
                  style: _vm.menuStyle,
                  on: {
                    mousedown: function ($event) {
                      $event.stopPropagation()
                    },
                    mouseup: function ($event) {
                      $event.stopPropagation()
                    },
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                _vm._l(_vm.priorities, function (p) {
                  return _c(
                    "a",
                    {
                      key: p,
                      staticClass: "priority-item",
                      class: { selected: p == _vm.value },
                      attrs: { href: "javascript:void(0)" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.select(p)
                        },
                      },
                    },
                    [
                      _c("span", {
                        staticClass: "priority-dot",
                        style: { backgroundColor: _vm.colorFor(p) },
                      }),
                      _vm._v(" " + _vm._s(_vm.$ct("priorities." + p)) + " "),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ],
        1
      )
    : _c("div", { staticClass: "priority-chips" }, [
        _vm.label
          ? _c("label", { staticClass: "w-label" }, [_vm._v(_vm._s(_vm.label))])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "chips" },
          _vm._l(_vm.priorities, function (p) {
            return _c(
              "w-chip",
              {
                key: p,
                staticClass: "priority-chip",
                class: { selected: p == _vm.value },
                style: _vm.chipStyle(p),
                attrs: { clickable: "" },
                on: {
                  click: function ($event) {
                    return _vm.select(p)
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.$ct("priorities." + p)) + " ")]
            )
          }),
          1
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }